export default [
  {
    "id": "mat-enem-0387",
    "numero": 1887,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O abandono escolar no ensino médio é um dos \nprincipais problemas da educação no Brasil. \nReduzir as taxas de abandono tem sido uma \ntarefa que exige persistência e ações continua-\ndas dos organismos responsáveis pela educa-\nção no país. \n \nO gráfico apresentado a seguir mostra as taxas \npercentuais de abandono no ensino médio, para \ntodo o país, no período de 2007 a 2010, em que \nse percebe uma queda a partir de 2008. Com o \nobjetivo de reduzir de forma mais acentuada a \nevasão escolar são investidos mais recursos e \nintensificadas as ações, para se chegar a uma \ntaxa em torno de 5,2% ao final do ano de 2013. \n \n \nQual a taxa de redução anual que deve ser ob-\ntida para que se chegue ao patamar desejado \npara o final de 2013? Considere (0,8)3 = 0,51. \n \n \nA) 20% \nB) 41% \nC) 51% \nD) 49% \nE) 10%",
    "alternativas": {
      "D": "49%",
      "E": "10%",
      "A": "20%",
      "B": "41%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 387,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0388",
    "numero": 1888,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "No mês de setembro de 2011, a Petrobras atin-\ngiu a produção diária de 129 mil barris de petró-\nleo na área do pré-sal no Brasil. O volume de \num barril de petróleo corresponde a 159 litros. \n \nDe acordo com essas informações, em setem-\nbro de 2011, a produção diária, em m3, atingida \npela Petrobras na área do pré-sal no Brasil foi \nde: \n \nA) 20,511. \nB) 205110. \nC) 20511. \nD) 20511000. \nE) 2051100.",
    "alternativas": {
      "B": "205110.",
      "C": "20511.",
      "E": "2051100.",
      "A": "20,511."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 388,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0389",
    "numero": 1889,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma aluna registrou as notas de matemática \nobtidas nos 3 primeiros bimestres do ano letivo \ne seus respectivos pesos no quadro a seguir. \n \n \n \nEla ainda não sabe qual será sua nota de ma-\ntemática no quarto bimestre, mas sabe que o \npeso dessa nota na média final é 4. As notas \nvariam de zero a dez, sendo permitida apenas \numa casa na parte decimal (caso contrário a \nnota será arredondada, usando como critério \n“se o algarismo da segunda casa decimal é \nmaior ou igual a 5, então o algarismo na primei-\nra casa decimal será acrescido de uma unida-\nde”). A média final mínima para aprovação na \nescola dessa aluna é 7. Se ela obtiver média \nfinal inferior a 7, precisará realizar uma outra \nprova que substitua a menor das notas bimes-\ntrais, de modo a alcançar a média 7 (mantidos \nos mesmos pesos anteriores). \n \nSe essa aluna precisar realizar uma prova para \nsubstituir a nota que obteve no primeiro bimes-\ntre, e tal nota precisar ser igual a 4,8, é porque a \nnota que ela obteve no quarto bimestre foi: \n \nA) 9,2. \nB) 7,3. \nC) 2,3. \nD) 10,0. \nE) 7,9.",
    "alternativas": {
      "C": "2,3.",
      "D": "10,0.",
      "E": "7,9.",
      "B": "7,3."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 389,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0390",
    "numero": 1890,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Nas empresas em geral, são utilizados dois \ntipos de copos plásticos descartáveis, ambos \ncom a forma de troncos de cones circulares \nretos: \n \n• copos pequenos, para a ingestão de café: \nraios das bases iguais a 2,4 cm e 1,8 cm e altu-\nra igual a 3,6 cm; \n \n• copos grandes, para a ingestão de água: raios \ndas bases iguais a 3,6 cm e 2,4 cm e altura \nigual a 8,0 cm. \n \nUma dessas empresas resolve substituir os dois \nmodelos de copos descartáveis, fornecendo \npara cada um de seus funcionários canecas \ncom a forma de um cilindro circular reto de altu-\nra igual a 6 cm e raio da base de comprimento \nigual a y centímetros. Tais canecas serão usa-\ndas tanto para beber café como para beber \nágua. \n \nSabe-se que o volume de um tronco de cone \ncircular reto, cujos raios das bases são respecti-\nvamente iguais a R e r e a altura é h, é dado \npela expressão: \n \n \n \nO raio y da base dessas canecas deve ser tal \nque y2 seja, no mínimo, igual a: \n \n \nA) 14,824 cm. \nB) 2,664 cm. \nC) 12,160 cm. \nD) 7,412 cm. \nE) 19,840 cm.",
    "alternativas": {
      "B": "2,664 cm.",
      "C": "12,160 cm.",
      "D": "7,412 cm.",
      "E": "19,840 cm."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 390,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0391",
    "numero": 1891,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um pequeno caminhão dispõe de dois reserva-\ntórios vazios, cada um com capacidade de 2000 \nkg, os quais serão utilizados para transportar a \nprodução de milho e soja até um centro consu-\nmidor. No centro de abastecimento abre-se o \nregistro de um primeiro silo às 12 horas para \nalimentar o reservatório 1 com milho, numa taxa \nde 120kg por minuto. Passados cinco minutos, \nabre-se o registro de um segundo silo para ali-\nmentar o reservatório 2 com soja, numa taxa de \n80 kg por minuto. Considere que a encomenda \nde milho no centro consumidor seja de 1800kg e \nque, pela lei rodoviária local, a carga máxima a \nser transportada por caminhão seja de 3400kg. \n \n \n \nNestas condições, em que instantes devem ser \nfechados os registros dos silos 1 e 2, respecti-\nvamente, para que a quantidade de soja trans-\nportada seja a máxima possível? \n \nA) 12h15min e 12h30min \nB) 12h15min e 12h27min30seg \nC) 12h15min e 12h32min30seg \nD) 12h15min e 12h20min \nE) 12h15min e 12h25min",
    "alternativas": {
      "E": "12h15min e 12h25min",
      "A": "12h15min e 12h30min",
      "C": "12h15min e 12h32min30seg",
      "D": "12h15min e 12h20min"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 391,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0392",
    "numero": 1892,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um professor, ao fazer uma atividade de origa-\nmi (dobraduras) com seus alunos, pede para \nque estes dobrem um pedaço de papel em for-\nma triangular, como na figura a seguir, de modo \nque M e N sejam pontos médios respectivamen-\nte de AB e AC, e D, ponto do lado BC, indica a \nnova posição do vértice A do triângulo ABC. \n \n \n \nSe ABC é um triângulo qualquer, após a cons-\ntrução, são exemplos de triângulos isósceles os \ntriângulos: \n \n \nA) CND e NDM. \nB) CAD e ADB. \nC) CMA e CMB. \nD) NAM e NDM. \nE) CND e DMB.",
    "alternativas": {
      "E": "CND e DMB.",
      "A": "CND e NDM.",
      "B": "CAD e ADB.",
      "D": "NAM e NDM."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 392,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0393",
    "numero": 1893,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O cristalino, que é uma lente do olho humano, \ntem a função de fazer ajuste fino na focalização, \nao que se chama acomodação. À perda da ca-\npacidade de acomodação com a idade chama-\nmos presbiopia. A acomodação pode ser deter-\nminada por meio da convergência do cristalino. \nSabe-se que a convergência de uma lente, para \npequena distância focal em metros, tem como \nunidade de medida a diopria (di). \n \nA presbiopia, representada por meio da relação \nentre a convergência máxima Cmax (em di) e a \nidade T (em anos), é mostrada na figura seguin-\nte. \n \n \n \nConsiderando esse gráfico, as grandezas con-\nvergência máxima Cmax e idade T estão relacio-\nnadas algebricamente pela expressão: \n \n \nA) Cmax = log2 (T2 –70T + 600) \nB) Cmax = 2–T \nC) Cmax = –0,16T + 9,6 \nD) Cmax = 0,16T + 9,6 \nE) Cmax = T2 – 70T + 600",
    "alternativas": {
      "B": "Cmax = 2–T",
      "C": "Cmax = –0,16T + 9,6",
      "D": "Cmax = 0,16T + 9,6",
      "A": "Cmax = log2 (T2 –70T + 600)"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 393,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0394",
    "numero": 1894,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O governo de um país criou o Fundo da Soja e \ndo Milho, que tem como expectativa inicial arre-\ncadar, por ano, R$ 36,14 milhões para investi-\nmento em pesquisas relacionadas aos principais \nprodutos da agricultura. Com isso, a cada ope-\nração de venda, seriam destinados ao Fundo \nR$ 0,28 por tonelada de soja e R$ 0,22 por to-\nnelada de milho comercializadas. Para este ano, \nespera-se que as quantidades de toneladas \nproduzidas, de soja e de milho, juntas, seja \n150,5 milhões. \n \nFoi pedido a cinco funcionários do Fundo, An-\ndré, Bruno, Caio, Douglas e Eduardo, que apre-\nsentassem um sistema que modelasse os da-\ndos apresentados. Cada funcionário apresentou \num sistema diferente, considerando x e y como \nas quantidades de toneladas comercializadas, \nrespectivamente, de soja e de milho. O resulta-\ndo foi o seguinte: \n \n \n \nO funcionário que fez a modelagem correta foi: \n \nA) Eduardo. \nB) Douglas. \nC) Bruno. \nD) André. \nE) Caio.",
    "alternativas": {
      "C": "Bruno.",
      "D": "André.",
      "A": "Eduardo.",
      "B": "Douglas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 394,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0395",
    "numero": 1895,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Os procedimentos de decolagem e pouso de \numa aeronave são os momentos mais críticos \nde operação, necessitando de concentração \ntotal da tripulação e da torre de controle dos \naeroportos.  \n \nSegundo levantamento da Boeing, realizado em \n2009, grande parte dos acidentes aéreos com \nvítimas ocorre após iniciar-se a fase de descida \nda aeronave. Desta forma, é essencial para os \nprocedimentos adequados de segurança moni-\ntorar-se o tempo de descida da aeronave. \n \nA tabela mostra a altitude y de uma aeronave, \nregistrada pela torre de controle, t minutos após \no início dos procedimentos de pouso. \n \n \n \nDe acordo com os dados apresentados, a rela-\nção entre y e t é dada por: \n \nA) y = – 400 t \nB) y = 10 000 – 400 t \nC) y = – 2 000 t \nD) y = 8 000 – 400 t \nE) y = 10 000 – 2 000 t",
    "alternativas": {
      "D": "y = 8 000 – 400 t",
      "E": "y = 10 000 – 2 000 t",
      "B": "y = 10 000 – 400 t",
      "C": "y = – 2 000 t"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 395,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0396",
    "numero": 1896,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma maneira muito útil de se criar belas figuras \ndecorativas utilizando a matemática é pelo pro-\ncesso de autossemelhança, uma forma de se \ncriar fractais. Informalmente, dizemos que uma \nfigura é autossemelhante se partes dessa figura \nsão semelhantes à figura vista como um todo. \nUm exemplo clássico é o Carpete de Sierpinski, \ncriado por um processo recursivo, descrito a \nseguir: \n \n• Passo 1: Considere um quadrado dividido em \nnove quadrados idênticos (Figura 1). Inicia-se o \nprocesso removendo o quadrado central, res-\ntando 8 quadrados pretos (Figura 2). \n \n• Passo 2: Repete-se o processo com cada um \ndos quadrados restantes, ou seja, divide-se \ncada um deles em 9 quadrados idênticos e re-\nmove-se o quadrado central de cada um, res-\ntando apenas os quadrados pretos (Figura 3). \n \n• Passo 3: Repete-se o passo 2. \n \n \n \nAdmita que esse processo seja executado 3 \nvezes, ou seja, divide-se cada um dos quadra-\ndos pretos da Figura 3 em 9 quadrados idênti-\ncos e remove-se o quadrado central de cada um \ndeles. \n \nO número de quadrados pretos restantes nesse \nmomento é: \n \nA) 576. \nB) 512. \nC) 648. \nD) 568. \nE) 64.",
    "alternativas": {
      "D": "568.",
      "E": "64.",
      "A": "576.",
      "B": "512."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 396,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0397",
    "numero": 1897,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Em uma das paredes de um depósito existem \ncompartimentos de mesmo tamanho para arma-\nzenamento de caixas de dimensões frontais a e \nb. A terceira dimensão da caixa coincide com a \nprofundidade de cada um dos compartimentos. \nInicialmente as caixas são arrumadas, em cada \num deles, como representado na Figura 1. A fim \nde aproveitar melhor o espaço, uma nova pro-\nposta de disposição das caixas foi idealizada e \nestá indicada na Figura 2. Essa nova proposta \npossibilitaria o aumento do número de caixas \narmazenadas de 10 para 12 e a eliminação de \nfolgas. \n \n \n \nÉ possível ocorrer a troca de arrumação segun-\ndo a nova proposta? \n \nA) Sim, porque a nova disposição de caixas \nficaria acomodada perfeitamente no comparti-\nmento de 32 cm de altura por 45 cm de largura. \nB) Sim, porque a nova disposição das caixas \nficaria acomodada perfeitamente no comparti-\nmento de 20 cm de altura por 27 cm de largura.  \nC) Sim, pois efetivamente aumentaria o número \nde caixas e reduziria o número de folgas para \napenas uma de 2 cm na largura do comparti-\nmento. \nD) Não, porque, para aceitar a segunda propos-\nta, seria necessário praticamente dobrar a altura \ne reduzir à metade a largura do compartimento.  \nE) Não, porque a segunda proposta deixa uma \nfolga de 4 cm na altura do compartimento, que é \nde 12 cm, o que permitiria colocar um número \nmaior de caixas.",
    "alternativas": {
      "A": "Sim, porque a nova disposição de caixas ficaria acomodada perfeitamente no comparti- mento de 32 cm de altura por 45 cm de largura.",
      "B": "Sim, porque a nova disposição das caixas ficaria acomodada perfeitamente no comparti- mento de 20 cm de altura por 27 cm de largura.",
      "D": "Não, porque, para aceitar a segunda propos- ta, seria necessário praticamente dobrar a altura e reduzir à metade a largura do compartimento.",
      "E": "Não, porque a segunda proposta deixa uma folga de 4 cm na altura do compartimento, que é de 12 cm, o que permitiria colocar um número maior de caixas."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 397,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0398",
    "numero": 1898,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma família deseja realizar um jantar comemo-\nrativo de um casamento e dispõe para isso de \num salão de festas de um clube, onde a área \ndisponível para acomodação das mesas é de \n500 m2.  \n \nAs 100 mesas existentes no salão encontram-se \nnormalmente agrupadas duas a duas, compor-\ntando 6 cadeiras.  \n \nA área de cada mesa é de 1 m2 e o espaço ne-\ncessário em torno deste agrupamento, para \nacomodação das cadeiras e para circulação, é \nde 6 m2.  \n \nAs mesas podem ser dispostas de maneira iso-\nlada, comportando 4 pessoas cada. Nessa situ-\nação, o espaço necessário para acomodação \ndas cadeiras e para circulação é de 4 m2. O \nnúmero de convidados previsto para o evento é \nde 400 pessoas. \n \nPara poder acomodar todos os convidados sen-\ntados, com as mesas existentes e dentro da \nárea disponível para acomodação das mesas e \ncadeiras, como deverão ser organizadas as \nmesas? \n \nA) Um terço das mesas separadas e dois terços \nagrupadas duas a duas. \nB) Todas deverão ser separadas. \nC) Sessenta por cento das mesas separadas e \nquarenta por cento agrupadas duas a duas. \nD) Todas mantidas no agrupamento original de \nduas mesas. \nE) Um quarto das mesas separadas e o restante \nem agrupamento de duas a duas.",
    "alternativas": {
      "A": "Um terço das mesas separadas e dois terços agrupadas duas a duas.",
      "B": "Todas deverão ser separadas.",
      "C": "Sessenta por cento das mesas separadas e quarenta por cento agrupadas duas a duas.",
      "E": "Um quarto das mesas separadas e o restante em agrupamento de duas a duas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 398,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0399",
    "numero": 1899,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Uma loja resolveu fazer uma promoção de um \ndeterminado produto que custava R$ 100,00 em \nfevereiro, da seguinte maneira: em março, ela \ndeu um desconto de 10% sobre o preço do pro-\nduto em fevereiro; em abril, deu mais 10% de \ndesconto sobre o preço do produto em março. \nTendo obtido uma venda substancial, a loja \nresolveu aumentar o preço do produto da se-\nguinte maneira: em maio, a loja aumentou em \n10% o preço de abril e, em junho, a loja aumen-\ntou em mais 10% o preço de maio. \n \nDesta forma, o preço deste produto, no final de \njunho, era: \n \nA) R$ 97,20. \nB) R$ 96,00. \nC) R$ 99,00. \nD) R$ 98,01. \nE) R$ 100,00.",
    "alternativas": {
      "D": "R$ 98,01.",
      "A": "R$ 97,20.",
      "B": "R$ 96,00.",
      "C": "R$ 99,00."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 399,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0400",
    "numero": 1900,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Pensando em desenvolver atividade física e \nreduzir gasto com energia elétrica em sua resi-\ndência, uma pessoa resolveu instalar uma bom-\nba d’água acoplada a uma bicicleta ergométrica. \nApós alguns dias de atividade física, ela obser-\nvou que, pedalando durante uma hora, o volume \nmédio de água bombeada para o seu reservató-\nrio era de 500 litros. Esta pessoa observou, \nainda, que o consumo diário em sua casa é de \n550 litros de água. \n \nQual a atitude, em relação ao tempo de exercí-\ncio diário, essa pessoa deve tomar para suprir \nexatamente o consumo diário de água da sua \ncasa? \n \nA) Aumentar o seu tempo diário de exercício na \nbicicleta em 6 minutos. \nB) Reduzir o seu tempo diário de exercício na \nbicicleta em 6 minutos. \nC) Aumentar o seu tempo diário de exercício na \nbicicleta em 10 minutos. \nD) Reduzir o seu tempo diário de exercício na \nbicicleta em 10 minutos. \nE) Aumentar o seu tempo diário de exercício na \nbicicleta em 5 minutos.",
    "alternativas": {
      "E": "Aumentar o seu tempo diário de exercício na bicicleta em 5 minutos.",
      "A": "Aumentar o seu tempo diário de exercício na bicicleta em 6 minutos.",
      "C": "Aumentar o seu tempo diário de exercício na bicicleta em 10 minutos.",
      "D": "Reduzir o seu tempo diário de exercício na bicicleta em 10 minutos."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 400,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0401",
    "numero": 1901,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Parece que foi ontem. Há 4,57 bilhões de anos, \numa gigantesca nuvem de partículas entrou em \ncolapso e formou o nosso Sistema Solar. Demo-\nraram míseros 28 milhões de anos — um piscar \nde olhos em termos geológicos — para que a \nTerra surgisse. Isso aconteceu há 4,54 bilhões \nde anos. No começo, a superfície do planeta era \nmole e muito quente, da ordem de 1 200 °C. \nNão demorou tanto assim para a crosta ficar \nmais fria e surgirem os mares e a terra; isso \naconteceu há 4,2 bilhões de anos. O nosso \nSistema Solar se formou, em anos, há: \n \nA) 4570000000. \nB) 4570. \nC) 4570000000000000. \nD) 4570000. \nE) 4570000000000.",
    "alternativas": {
      "A": "4570000000.",
      "C": "4570000000000000.",
      "D": "4570000.",
      "E": "4570000000000."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 401,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0402",
    "numero": 1902,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "O Índice de Massa Corporal, abreviadamente \nIMC, é uma medida internacional adotada pela \nOrganização Mundial de Saúde (OMS) para \nindicar se uma pessoa está com “peso” excessi-\nvo para sua altura. O cálculo do IMC é dado \npela fórmula IMC = m/h2, sendo m a massa da \npessoa, medida em kg, e h a sua altura, em \nmetros. Os valores da tabela foram ligeiramente \nadaptados com relação aos adotados pela \nOMS, para simplicidade nos cálculos. \n \n \nAssim, segundo a OMS, um indivíduo de 2,10 \nmetros de altura que pesa 80 kg tem IMC inferi-\nor a 19, sendo classificado como “abaixo do \npeso”. \n \nSe um indivíduo de 144 kg e 2 metros de altura \nperder 64 kg numa dieta, então este indivíduo \nmigrará da classe: \n \nA) obesidade mórbida para a classe peso nor-\nmal. \nB) obesidade do tipo 1 para a classe abaixo do \npeso. \nC) sobrepeso para a classe peso normal. \nD) obesidade do tipo 1 para a classe peso nor-\nmal. \nE) obesidade mórbida para a classe abaixo do \npeso.",
    "alternativas": {
      "E": "obesidade mórbida para a classe abaixo do peso.",
      "A": "obesidade mórbida para a classe peso nor- mal.",
      "B": "obesidade do tipo 1 para a classe abaixo do peso.",
      "D": "obesidade do tipo 1 para a classe peso nor- mal."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 402,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0403",
    "numero": 1903,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Um pintor dispõe de 35 litros de tinta vermelha e \nde 30 litros de tinta branca. Ele deseja misturar \nessas tintas na proporção de 5 litros de tinta \nvermelha para cada 3 litros de tinta branca para \nobter um tom de tinta mais claro. Para obter o \nmaior volume possível de tinta misturada, ele \ndeverá utilizar toda a tinta disponível de uma \ndas cores e sobrará uma certa quantidade de \ntinta da outra cor. \n \nQuantos litros de tinta sobrarão sem serem mis-\nturados? \n \n \nA) 5. \nB) 17. \nC) 9. \nD) 12. \nE) 14.",
    "alternativas": {
      "A": "5.",
      "B": "17.",
      "C": "9.",
      "E": "14."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 403,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0404",
    "numero": 1904,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "No ano de 2010 o DataSenado realizou uma \npesquisa intitulada “Condições de vida das pes-\nsoas com deficiência no Brasil”. A pesquisa \nouviu 1 165 pessoas com deficiência e uma das \nquestões foi a seguinte: “Para você, nos últimos \nanos, o preconceito em relação às pessoas com \ndeficiência está igual, aumentando ou diminuin-\ndo?”. A porcentagem das respostas a esta per-\ngunta é mostrada na tabela a seguir. \n \n \nPelos dados contidos na tabela, o número que \nmais se aproxima da quantidade de pessoas \nque responderam “diminuindo” é \n \nA) 687. \nB) 69. \nC) 116. \nD) 361. \nE) 1 106.",
    "alternativas": {
      "B": "69.",
      "C": "116.",
      "D": "361.",
      "E": "1 106."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.2",
    "numeroOriginal": 404,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0406",
    "numero": 1906,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "As torres Puerta de Europa são duas torres \ninclinadas uma contra a outra, construídas nu-\nma avenida de Madri, na Espanha. A inclinação \ndas torres é de 15° com a vertical e elas têm, \ncada uma, uma altura de 114 m (a altura é indi-\ncada na figura como o segmento AB). Estas \ntorres são um bom exemplo de um prisma oblí-\nquo de base quadrada e uma delas pode ser \nobservada na imagem. \n \n \n \nUtilizando 0,26 como valor aproximado para a \ntangente de 15° e duas casas decimais nas \noperações, descobre-se que a área da base \ndesse prédio ocupa na avenida um espaço: \n \nA) menor que 100 m2. \nB) entre 100 m2 e 300 m2. \nC) entre 300 m2 e 500 m2. \nD) entre 500 m2 e 700 m2. \nE) maior que 700 m2.",
    "alternativas": {
      "D": "entre 500 m2 e 700 m2.",
      "E": "maior que 700 m2.",
      "A": "menor que 100 m2.",
      "C": "entre 300 m2 e 500 m2."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 406,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0407",
    "numero": 1907,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "As notas de um professor que participou de um \nprocesso seletivo, em que a banca avaliadora \nera composta por cinco membros, são apresen-\ntadas no gráfico. Sabe-se que cada membro da \nbanca atribuiu duas notas ao professor, uma \nrelativa aos conhecimentos específicos da área \nde atuação e outra, aos conhecimentos peda-\ngógicos, e que a média final do professor foi \ndada pela média aritmética de todas as notas \natribuídas pela banca avaliadora.  \n \n \n \nUtilizando um novo critério, essa banca avalia-\ndora resolveu descartar a maior e a menor no-\ntas atribuídas ao professor. \n \nA nova média, em relação à média anterior, é: \n \nA) 0,25 ponto maior. \nB) 1,00 ponto maior, \nC) 1,00 ponto menor. \nD) 1,25 ponto maior. \nE) 2,00 pontos menor.",
    "alternativas": {
      "B": "1,00 ponto maior,",
      "D": "1,25 ponto maior.",
      "E": "2,00 pontos menor.",
      "A": "0,25 ponto maior."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 407,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0408",
    "numero": 1908,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Um banco solicitou aos seus clientes a criação \nde uma senha pessoal de seis dígitos, formada \nsomente por algarismos de 0 a 9, para acesso à \nconta corrente pela Internet. \n \nEntretanto, um especialista em sistemas de \nsegurança eletrônica recomendou à direção do \nbanco recadastrar seus usuários, solicitando, \npara cada um deles, a criação de uma nova \nsenha com seis dígitos, permitindo agora o uso \ndas 26 letras do alfabeto, além dos algarismos \nde 0 a 9.  \n \nNesse novo sistema, cada letra maiúscula era \nconsiderada distinta de sua versão minúscula. \nAlém disso, era proibido o uso de outros tipos \nde caracteres. \nUma forma de avaliar uma alteração no sistema \nde senhas é a verificação do coeficiente de me-\nlhora, que é a razão do novo número de possibi-\nlidades de senhas em relação ao antigo. \n \nO coeficiente de melhora da alteração reco-\nmendada é: \n \nA) \n626\n106 \n \nB) \n62!\n10! \n \nC) \n62! 4!\n10! 56! \n \nD) 62! – 10! \n \nE) 626 - 106",
    "alternativas": {
      "E": "626 - 106",
      "A": "626 106",
      "B": "62! 10!",
      "C": "62! 4! 10! 56!"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 408,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0409",
    "numero": 1909,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma torneira não foi fechada corretamente e \nficou pingando, da meia-noite às seis horas da \nmanhã, com a frequência de uma gota a cada \ntrês segundos. Sabe-se que cada gota d’agua \ntem volume de 0,2 mL. \n \nQual foi o valor mais aproximado do total de \nágua desperdiçada nesse período, em litros? \n \nA) 0,2  \nB) 1,2  \nC) 1,4 \nD) 12,9 \nE) 64,8",
    "alternativas": {
      "C": "1,4",
      "D": "12,9",
      "A": "0,2",
      "B": "1,2"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 409,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0410",
    "numero": 1910,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Um comerciante visita um centro de vendas \npara fazer cotação de preços dos produtos que \ndeseja comprar. Verifica que se aproveita 100% \nda quantidade adquirida de produtos do tipo A, \nmas apenas 90% de produtos do tipo B. Esse \ncomerciante deseja comprar uma quantidade de \nprodutos, obtendo o menor custo/benefício em \ncada um deles. O quadro mostra o preço por \nquilograma, em reais, de cada produto comerci-\nalizado. \n \n \n \nOs tipos de arroz, feijão, soja e milho que de-\nvem ser escolhidos pelo comerciante são, res-\npectivamente, \nA) A, A, A, A.  \nB) A, B, A, B. \nC) A, B, B, A. \nD) B, A, A, B. \nE) B, B, B, B.",
    "alternativas": {
      "E": "B, B, B, B.",
      "B": "A, B, A, B.",
      "C": "A, B, B, A.",
      "D": "B, A, A, B."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 410,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0411",
    "numero": 1911,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Em um sistema de dutos, três canos iguais, de \nraio externo 30cm, são soldados entre si e colo-\ncados dentro de um cano de raio maior, de me-\ndida R. Para posteriormente ter fácil manuten-\nção, é necessário haver uma distância de 10cm \nentre os canos soldados e o cano de raio maior. \nEssa distância é garantida por um espaçador de \nmetal, conforme a figura: \n \n \n \nUtilize 1,7 como aproximação para √3. \n \nO valor de R, em centímetros, é igual a: \n \nA) 64,0. \nB) 65,5. \nC) 74,0. \nD) 81,0. \nE) 91,0.",
    "alternativas": {
      "C": "74,0.",
      "D": "81,0.",
      "E": "91,0.",
      "A": "64,0."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 411,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0412",
    "numero": 1912,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "O índice de eficiência utilizado por um produtor \nde leite qualificar suas vacas é dado pelo produ-\nto do tempo de lactação (em dias) pela produ-\nção média diária de leite (em kg), dividido pelo \nintervalo entre partos (em meses). Para esse \nprodutor, a vaca é qualificada como eficiente \nquando esse índice é, no mínimo, 281 quilo-\ngramas por mês, mantendo sempre as mesmas \ncondições de manejo (alimentação, vacinação e \noutros). Na comparação de duas ou mais vacas, \na mais eficiente é a que tem maior índice. \n \nA tabela, na sequência, apresenta os dados \ncoletados de cinco vacas: \nDados relativos à produção das vacas \n \n \n \nApós a análise dos dados, o produtor avaliou \nque a vaca mais eficiente é a: \n \nA) Malhada. \nB) Mamona \nC) Maravilha. \nD) Mateira. \nE) Mimosa.",
    "alternativas": {
      "B": "Mamona",
      "D": "Mateira.",
      "E": "Mimosa.",
      "A": "Malhada."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 412,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0413",
    "numero": 1913,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A Secretaria de Saúde de um município avalia \num programa que disponibiliza, para cada aluno \nde uma escola municipal, uma bicicleta, que \ndeve ser usada no trajeto de ida e volta, entre \nsua casa e a escola. Na fase de implantação do \nprograma, o aluno que morava mais distante da \nescola realizou sempre o mesmo trajeto, repre-\nsentado na figura, na escala 1:25000, por um \nperíodo de cinco dias. \n \n \n \nQuantos quilômetros esse aluno percorreu na \nfase de implantação do programa? \n \nA) 4 \nB) 8 \nC) 16 \nD) 20 \nE) 40",
    "alternativas": {
      "B": "8",
      "C": "16",
      "E": "40",
      "A": "4"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 413,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0414",
    "numero": 1914,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A cidade de Guarulhos (SP) tem o 8º PIB muni-\ncipal do Brasil, além do maior aeroporto da \nAmérica do Sul. Em proporção, possui a eco-\nnomia que mais cresce em indústrias, conforme \nmostra o gráfico. \n \n \n \nAnalisando os dados percentuais do gráfico, \nqual a diferença entre o maior e o menor centro \nem crescimento no polo das indústrias? \n \nA) 75,28 \nB) 64,09 \nC) 56,95 \nD) 45,76 \nE) 30,07",
    "alternativas": {
      "D": "45,76",
      "A": "75,28",
      "B": "64,09",
      "C": "56,95"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 414,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0415",
    "numero": 1915,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Em um certo teatro, as poltronas são divididas \nem setores. A figura apresenta a vista do setor 3 \ndesse teatro, no qual as cadeiras escuras estão \nreservadas e as claras não foram vendidas. \n \n \n \nA razão que representa a quantidade de cadei-\nras reservadas do setor 3 em relação ao total de \ncadeiras desse mesmo setor é: \n \nA) 17/10 \nB) 17/53 \nC) 53/70 \nD) 5317 \nE) 70/17",
    "alternativas": {
      "D": "5317",
      "E": "70/17",
      "A": "17/10",
      "C": "53/70"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 415,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0416",
    "numero": 1916,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma loja acompanhou o número de comprado-\nres de dois produtos, A e B, durante os meses \nde janeiro, fevereiro e março de 2012. Com \nisso, obteve este gráfico: \n \n \n \nA loja sorteará um brinde entre os compradores \ndo produto A e outro brinde entre os comprado-\nres do produto B. Qual a probabilidade de que \nos dois sorteados tenham feito suas compras \nem fevereiro de 2012? \n \nA) 1/20 \nB) 3/242 \nC) 5/22 \nD) 6/25 \nE) 7/15",
    "alternativas": {
      "E": "7/15",
      "A": "1/20",
      "C": "5/22",
      "D": "6/25"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 416,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0417",
    "numero": 1917,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Para o reflorestamento de uma área, deve-se \ncercar totalmente, com tela, os lados de um \nterreno, exceto o lado margeado pelo rio, con-\nforme a figura. Cada rolo de tela que será com-\nprado para confecção da cerca contém 48 me-\ntros de comprimento. \n \n \n \nA quantidade mínima de rolos que deve ser \ncomprada para cercar esse terreno é: \n \nA) 6. \nB) 7. \nC) 8. \nD) 11. \nE) 12.",
    "alternativas": {
      "C": "8.",
      "E": "12.",
      "A": "6.",
      "B": "7."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 417,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0418",
    "numero": 1918,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Um dos grandes problemas enfrentados nas \nrodovias brasileiras é o excesso de carga trans-\nportada pelos caminhões. Dimensionado para o \ntráfego dentro dos limites legais de carga, o piso \ndas estradas se deteriora com o peso excessivo \ndos caminhões. Além disso, o excesso de carga \ninterfere na capacidade de frenagem e no funci-\nonamento da suspensão do veículo, causas \nfrequentes de acidentes. \n \nCiente dessa responsabilidade e com base na \nexperiência adquirida com pesagens, um cami-\nnhoneiro sabe que seu caminhão pode carregar \nno máximo 1 500 telhas ou 1 200 tijolos. Consi-\nderando esse caminhão carregado com 900 \ntelhas, quantos tijolos, no máximo, podem ser \nacrescentados à carga de modo a não ultrapas-\nsar a carga máxima do caminhão? \n \nA) 300 tijolos  \nB) 360 tijolos \nC) 400 tijolos \nD) 480 tijolos \nE) 600 tijolos",
    "alternativas": {
      "C": "400 tijolos",
      "D": "480 tijolos",
      "A": "300 tijolos",
      "B": "360 tijolos"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 418,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0419",
    "numero": 1919,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "As projeções para a produção de arroz no perí-\nodo de 2012 – 2021, em uma determinada regi-\não produtora, apontam para uma perspectiva de \ncrescimento constante da produção anual. O \nquadro apresenta a quantidade de arroz, em \ntoneladas, que será produzida nos primeiros \nanos desse período, de acordo com essa proje-\nção. \n \n \n \nA quantidade total de arroz, em toneladas, que \ndeverá ser produzida no período de 2012 a \n2021 será de: \n \nA) 497,25. \nB) 500,85. \nC) 502,87. \nD) 558,75. \nE) 563,25.",
    "alternativas": {
      "D": "558,75.",
      "A": "497,25.",
      "B": "500,85.",
      "C": "502,87."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 419,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0420",
    "numero": 1920,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Numa escola com 1 200 alunos foi realizada \numa pesquisa sobre o conhecimento desses em \nduas línguas estrangeiras, inglês e espanhol. \nNessa pesquisa constatou-se que 600 alunos \nfalam inglês, 500 falam espanhol e 300 não \nfalam qualquer um desses idiomas. \n \nEscolhendo-se um aluno dessa escola ao acaso \ne sabendo-se que ele não fala inglês qual a \nprobabilidade de que esse aluno fale espanhol? \n \nA) 1/2 \nB) 5/8 \nC) 1/4 \nD) 5/6 \nE) 5/14",
    "alternativas": {
      "E": "5/14",
      "A": "1/2",
      "C": "1/4",
      "D": "5/6"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 420,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0422",
    "numero": 1922,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A parte interior de uma taça foi gerada pela \nrotação de uma parábola em torno de um eixo z, \nconforme mostra a figura.  \n \n \n \nA função real que expressa a parábola, no plano \ncartesiano da figura, é dada pela lei f(x) = \n3\n2 x2 – \n6x + C, onde C é a medida da altura do líquido \ncontido na taça, em centímetros. Sabe-se que o \nponto V, na figura, representa o vértice da pará-\nbola, localizado sobre o eixo x. \n \nNessas condições, a altura do líquido contido na \ntaça, em centímetros, é: \n \nA) 1. \nB) 2. \nC) 4. \nD) 5. \nE) 6.",
    "alternativas": {
      "D": "5.",
      "E": "6.",
      "A": "1.",
      "B": "2."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 422,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0423",
    "numero": 1923,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Muitos processos fisiológicos e bioquímicos, tais \ncomo batimentos cardíacos e taxa de respira-\nção, apresentam escalas construídas a partir da \nrelação entre superfície e massa (ou volume) do \nanimal. Uma dessas escalas, por exemplo, con-\nsidera que o “cubo da área S da superfície de \num mamífero é proporcional ao quadrado de \nsua massa M”. \n \nIsso é equivalente a dizer que, para uma cons-\ntante k > 0, a área S pode ser escrita em função \nde M por meio da expressão: \n \nA) S = k . M \nB) S = k . M1/3 \nC) S = k1/3 . M1/3 \nD) S = k1/3 . M2/3 \nE) S = k1/3 . M2",
    "alternativas": {
      "D": "S = k1/3 . M2/3",
      "A": "S = k . M",
      "B": "S = k . M1/3",
      "C": "S = k1/3 . M1/3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 423,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0425",
    "numero": 1925,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma indústria tem um reservatório de água com \ncapacidade para 900 m3. Quando há necessi-\ndade de limpeza do reservatório, toda a água \nprecisa ser escoada.  \n \nO escoamento da água é feito por seis ralos, e \ndura 6 horas quando o reservatório está cheio. \nEsta indústria construirá um novo reservatório, \ncom capacidade de 500 m3, cujo escoamento da \nágua deverá ser realizado em 4 horas, quando o \nreservatório estiver cheio.  \n \nOs ralos utilizados no novo reservatório deverão \nser idênticos aos do já existente. \n \nA quantidade de ralos do novo reservatório de-\nverá ser igual a: \n \nA) 2 \nB) 4 \nC) 5 \nD) 8 \nE) 9",
    "alternativas": {
      "E": "9",
      "B": "4",
      "C": "5",
      "D": "8"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 425,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0426",
    "numero": 1926,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma fábrica de fórmicas produz placas quadra-\ndas de lados de medida igual a y centímetros. \nEssas placas são vendidas em caixas com N \nunidades e, na caixa, é especificada a área \nmáxima S que pode ser coberta pelas N placas. \nDevido a uma demanda do mercado por placas \nmaiores, a fábrica triplicou a medida dos lados \nde suas placas e conseguiu reuni-las em uma \nnova caixa, de tal forma que a área coberta S \nnão fosse alterada. \n \nA quantidade X, de placas do novo modelo, em \ncada nova caixa será igual a: \n \nA) N/9 \nB) N/6 \nC) N/3 \nD) 3N \nE) 9N",
    "alternativas": {
      "C": "N/3",
      "D": "3N",
      "E": "9N",
      "A": "N/9"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 426,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0427",
    "numero": 1927,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Num parque aquático existe uma piscina infantil \nna forma de um cilindro circular reto, de 1 m de \nprofundidade e volume igual a 12 m3, cuja base \ntem raio R e centro O. Deseja-se construir uma \nilha de lazer seca no interior dessa piscina, \ntambém na forma de um cilindro circular reto, \ncuja base estará no fundo da piscina e com \ncentro da base coincidindo com o centro do \nfundo da piscina, conforme a figura. O raio da \nilha de lazer será r. Deseja-se que após a cons-\ntrução dessa ilha, o espaço destinado à água na \npiscina tenha um volume de, no mínimo, 4 m3. \n \nConsidere 3 como valor aproximado para 𝜋. \n \n, \n \nPara satisfazer as condições dadas, o raio má-\nximo da ilha de lazer r, em metros, estará mais \npróximo de: \n \nA) 1,6. \nB) 1,7. \nC) 2,0. \nD) 3,0. \nE) 3,8.",
    "alternativas": {
      "D": "3,0.",
      "E": "3,8.",
      "A": "1,6.",
      "B": "1,7."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 427,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0428",
    "numero": 1928,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "O contribuinte que vende mais de R$ 20 mil de \nações em Bolsa de Valores em um mês deverá \npagar Imposto de Renda. O pagamento para a \nReceita Federal consistirá em 15% do lucro \nobtido com a venda das ações. \n \nUm contribuinte que vende por R$ 34 mil um \nlote de ações que custou R$ 26 mil terá de pa-\ngar de Imposto de Renda à Receita Federal o \nvalor de \n \nA) R$ 900,00.  \nB) R$ 1 200,00. \nC) R$ 2 100,00.  \nD) R$ 3 900,00. \nE) R$ 5 100.00.",
    "alternativas": {
      "C": "R$ 2 100,00.",
      "E": "R$ 5 100.00.",
      "A": "R$ 900,00.",
      "B": "R$ 1 200,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 428,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0429",
    "numero": 1929,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Para se construir um contrapiso, é comum, na \nconstituição do concreto, se utilizar cimento, \nareia e brita, na seguinte proporção: 1 parte de \ncimento, 4 partes de areia e 2 partes de brita. \nPara construir o contrapiso de uma garagem, \numa construtora encomendou um caminhão \nbetoneira com 14 m3 de concreto. \n \nQual é o volume de cimento, em m3, na carga \nde concreto trazido pela betoneira? \n \nA) 1,75 \nB) 2,00 \nC) 2,33 \nD) 4,00 \nE) 8,00",
    "alternativas": {
      "D": "4,00",
      "A": "1,75",
      "B": "2,00",
      "C": "2,33"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 429,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];